import { render, staticRenderFns } from "./HandInOut.vue?vue&type=template&id=2c06171a&scoped=true"
import script from "./HandInOut.vue?vue&type=script&lang=js"
export * from "./HandInOut.vue?vue&type=script&lang=js"
import style0 from "./HandInOut.vue?vue&type=style&index=0&id=2c06171a&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c06171a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/publish/iot-cloud-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2c06171a')) {
      api.createRecord('2c06171a', component.options)
    } else {
      api.reload('2c06171a', component.options)
    }
    module.hot.accept("./HandInOut.vue?vue&type=template&id=2c06171a&scoped=true", function () {
      api.rerender('2c06171a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/control/components/HandInOut.vue"
export default component.exports